import styled from "styled-components";
import { color } from "../../../../shared/styles";

export const WarningMessage = styled.div`
    padding: 22px 24px;
    border-radius: 8px;
    background-color: ${color.status.DANGER_LIGHT};
    font-size: 16px;
    display: flex;
    gap: 8px;
`;

export const TagName = styled.span<{ itemType: 'product' | 'material' }>`
    margin-left: 8px;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 12px;
    background-color: ${props => props.itemType === 'product' ? color.primary.BLUE_B100 : color.status.WARNING};
    color: white;
    white-space: nowrap;
`;
